// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"637":"order","826":"index"}[chunkId] || chunkId) + "." + {"637":"6af87254","826":"21e81832","972":"8ea997cc"}[chunkId] + ".css";
};